'use strict';

module.exports = function($uibModal, dialog, Department, Member, $state, owners, departments, $translate, myTenant, Authentication, myDepartments) {
    var _this = this;
    this.loadingTagsDept = true;
    this.loadingTable = false;
    this.savingData = false;

    this.isAuthorized = Authentication.isAuthorized(['admin', 'owner'])
    // console.log('this.isAuthorized', this.isAuthorized == true);

    // TENANT VOOLKS CERTIFICATIONS
    this.myTenant = myTenant;
    _this.myTenant.load().then(() => {
        this.tenantId = _this.myTenant.get().id;
    })
    // this.voolksTenantId = "56fc21e402a3885f336d8d3f";
    // this.pampaTenantId = "60b0d8d8015d5f6b39cdbd57";
    // this.pampaEPTenantId = "5f159630815b7f852fbd1f6a";

    this.department = departments?.filter(function(department) {
        return department.id === $state.params.departmentId;
    })[0];

    this.persistDepartmentOwners = function() {
        if (_this.department && _this.department.id) {
            myDepartments.updateDepartmentOwners(_this.department.id, _this.department.owners);
        }
    }

    this.reloadTable = function() {
        this.loadingTable = true;
        return $state.go("dashboard.departments.department.admin", { departmentId: _this.department.id }, { reload: true })
    }

    this.addOwner = function() {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', '$stateParams', 'Department', 'currentMembers', function($uibModalInstance, $stateParams, Department, currentMembers) {
                var _this = this;
                this.members = [];
                this.currentMembers = currentMembers;
                this.addUsers = function () {

                if (!_this.members.length) {
                    return;
                }
                _this.loading = true;
                
                Department.addOwner({
                    departmentId: $stateParams.departmentId,
                }, {
                    id: _this.members.map(function (member) {
                        return member.id;
                    })
                })
                    .$promise
                    .then(function (member) {
                        $uibModalInstance.close(member.response);
                    })
                    .catch(function (error) {
                        _this.loading = false;
                        console.log(error);
                    });

                };
            }],
            templateUrl: 'dashboard-department-admin/dashboardAddUsersModal.html',
            controllerAs: 'modal',
            size: 'md',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                currentMembers: ['Member', function(Member) {
                    return Member.find({
                        filter: {
                            include: ['roles']
                        }
                    })
                    .$promise
                    .then(function(members) {
                        return members.filter(function(member) {
                            var roles = member.roles;
                            var admin = roles.filter(function(role) {
                                return role.name === 'admin';
                            });
                            var already_owner = false;
                            for (var i=0; i<_this.department.owners.length; i++)  {
                                if (member.id == _this.department.owners[i].id)   {
                                    already_owner = true;
                                    break;
                                }
                            }
                            if (admin.length || already_owner) {
                                return member;
                            }
                            return false;
                        });
                    });
                }]
            }
        }).result.then(function(members) {
            _this.department.owners = _this.department.owners.concat(members);
            _this.persistDepartmentOwners();
        });
    };

    this.addOwnerSupervisor = function() {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', '$stateParams', '$state', 'Department', 'Member', 'currentMembers', 'myDepartments', function($uibModalInstance, $stateParams, $state, Department, Member, currentMembers, myDepartments) {
                var _this = this;
                this.members = [];
                this.currentMembers = currentMembers;

                this.addUsers = function() {

                    if (!_this.members.length) {
                        return;
                    }
                    
                    _this.loading = true;
                    Department.addOwner({
                            departmentId: $stateParams.departmentId,
                        }, {
                            id: _this.members.map(function(m){return m.id})
                        })
                        .$promise
                        .then(function(member) {
                            member.response.forEach(function(m) {
                                Member.makesupervisor({
                                    userId: m.id
                                }).$promise                                
                                .catch(function(error) {
                                    console.log(error);
                                });                                
                            })
                            var depts = myDepartments.get();
                            if (depts) {
                                var d = depts.find(function (x) {
                                    return x.id == $stateParams.departmentId;
                                });
                                if (d) {
                                    d.owners = (d.owners || []).concat(member.response);
                                    myDepartments.set(depts);
                                }
                            }
                            $uibModalInstance.close(member.response);
                            $state.reload('dashboard.departments.department.admin');
                        })
                        .catch(function(error) {
                            _this.loading = false;
                            console.log(error);
                        });

                };
            }],
            templateUrl: 'dashboard-department-admin/dashboardAddUsersSupervisorModal.html',
            controllerAs: 'modal',
            size: 'md',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
                currentMembers: ['Member', function(Member) {
                    return Member.find({
                        filter: {
                            include: ['roles']
                        }
                    })
                    .$promise
                    .then(function(members) {
                        return members.filter(function(member) {
                            var roles = member.roles;
                            var admin = roles.filter(function(role) {
                                return role.name === 'admin';
                            });
                            var already_owner = false;
                            for (var i=0; i<_this.department.owners.length; i++)  {
                                if (member.id == _this.department.owners[i].id)   {
                                    already_owner = true;
                                    break;
                                }
                            }
                            if (admin.length || already_owner) {
                                return member;
                            }
                            return false;
                        });
                    });
                }]
            }
        });
    };

    // MODAL TAG DEPARTMENT
    this.tagsDepartment = function(department) {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-department-admin/dashboardAddDepartmentTagsModal.html',
            controller: [
                "$uibModalInstance",
                "BuilderDataService",
                "Department",
                "toast",
                "$translate",
                "loadingTagsDept",
                "savingData",
                "myDepartments",
                function ($uibModalInstance, BuilderDataService, Department, toast, $translate, loadingTagsDept, savingData, myDepartments) {
                    var _this = this;
                    _this.department = department;
                    _this.loadingTagsDept = loadingTagsDept;
                    _this.savingData = savingData;
                    
                    this.departmentTags = [];

                    this.getDepartmentTags = function () {
                        _this.departmentTags = [];
                        _this.loadingTagsDept = true

                        Department.tags({
                            id: this.department.id,
                        })
                        .$promise.then(function (data) {
                            _this.departmentTags = data?.sort(function(a, b) {
                                return a.name.localeCompare(b.name);
                            });;
                            _this.loadingTagsDept = false;
                        })
                        .catch(function (error) {
                            console.log(error);
                            _this.loadingTagsDept = false;
                        });
                    }

                    this.close = function () {
                        _this.savingData = true;
                        _this.loadingTagsDept = true;
                        myDepartments.load().then(function(dpts){
                            _this.savingData = false;
                            _this.loadingTagsDept = false;
                            $uibModalInstance.close();
                        });                        
                    };

                    this.addEditTag = function(department, type, tag) {
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'dashboard-department-admin/dashboardNewTagModal.html',
                            controller: [
                                "$uibModalInstance",
                                "BuilderDataService",
                                "Department",
                                "toast",
                                "$translate",
                                function ($uibModalInstance, BuilderDataService, Department, toast, $translate) {
                                    var _this = this;
                                    this.department = department;
                                    this.type = type;
                                    this.tagName = tag?.name || '';
                                    this.tagId = tag?.id || '';
                
                                    this.accept = function () {
                                        if (_this.type == 'new') {
                                            Department.tags.create({
                                                id: this.department.id
                                            }, {   
                                                name: this.tagName
                                            })
                                            .$promise.then(function (data) {
                                                $uibModalInstance.close(_this.type)
                                            })
                                            .catch(function (error) {
                                                toast.error($translate.instant('DASHBOARD.DASH_DEPT.ERROR_TAG_DEPT_NEW'));
                                                console.log(error);
                                            });
                                        } else if (_this.type == 'edit') {
                                            Department.tags.updateById({
                                                id: this.department.id,
                                                fk: this.tagId,
                                            },
                                            {
                                              name: this.tagName    
                                            })
                                            .$promise.then(function (data) {
                                                $uibModalInstance.close(_this.type)
                                            })
                                            .catch(function (error) {
                                                toast.error($translate.instant('DASHBOARD.DASH_DEPT.ERROR_TAG_DEPT_MODIFY'));
                                                console.log(error);
                                            });
                                        }
                                    }
                                    
                                    this.close = function () {
                                        $uibModalInstance.close();
                                    };
                                },
                            ],
                            controllerAs: "modal",
                            size: "md",
                            windowClass: "dialog",
                            bindToController: true,
                        }).result.then((result) => {
                            if (result == 'new' || result == 'edit') {
                                _this.getDepartmentTags();
                            }
                        }, function() {
                        });

                    }

                    this.deleteTag = function (department, tagToDelete) {
                        this.department = department;
                        this.tagToDelete = tagToDelete;
                        dialog
                            .confirm({
                                title: $translate.instant("DASHBOARD.DASH_DEPT.DEPT_TAG.DIAG_DEL.TITLE"),
                                body: $translate.instant("DASHBOARD.DASH_DEPT.DEPT_TAG.DIAG_DEL.BODY"),
                                accept: $translate.instant("DASHBOARD.DELETE"),
                                cancel: $translate.instant("DASHBOARD.CANCEL"),
                                size: "sm",
                            })
                            .then(function () {
                                Department.tags.destroyById({
                                    id: _this.department.id,
                                    fk: _this.tagToDelete.id
                                })
                                    .$promise.then(function () {
                                        _this.getDepartmentTags();
                                    })
                                    .catch(function (error) {
                                        console.log(error);
                                    });
                            });
                    };
                    this.getDepartmentTags();
                },
            ],
            controllerAs: "modal",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                loadingTagsDept: () => _this.loadingTagsDept,
                savingData: () => _this.savingData
            }
        }).result.then((result) => {
            _this.reloadTable();
        }, function() {
            _this.reloadTable();
        });
    };

    this.goToTagSync = () => {
        // console.log('Navigating to tagsync...');
        $state.go("dashboard.departments.department.tagsync", {
            departmentId: _this.department.id
        });
    }

};
